/** Loading placeholder for Script studio — matches ScriptWorkspaceStudioView shell colors. */
export default function ScriptWorkspaceSkeleton() {
  return (
    <div
      className={[
        '-mx-6 -mt-6 mb-0 min-h-[calc(100vh-4rem)] bg-[#f7f6f2] px-6 py-6',
        'dark:bg-gray-950 animate-pulse',
      ].join(' ')}
    >
      <div className="mb-2 h-4 w-40 max-w-[50%] rounded bg-[#d4d1ca]/90 dark:bg-gray-700" />
      <div className="mb-4 flex flex-wrap items-start gap-3">
        <div className="h-10 w-10 shrink-0 rounded-lg bg-[#d4d1ca]/90 dark:bg-gray-700" />
        <div className="min-w-0 flex-1 space-y-2">
          <div className="h-7 w-56 max-w-full rounded bg-[#d4d1ca]/90 dark:bg-gray-700" />
          <div className="h-4 w-80 max-w-full rounded bg-[#d4d1ca]/70 dark:bg-gray-600" />
          <div className="h-3 w-full max-w-xl rounded bg-[#d4d1ca]/50 dark:bg-gray-600" />
        </div>
      </div>
      <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_280px]">
        <div className="min-h-[360px] rounded-xl border border-[#d4d1ca] bg-[#f0eeea]/90 p-4 dark:border-gray-700 dark:bg-gray-900/40">
          <div className="mb-4 flex gap-2">
            <div className="h-8 w-24 rounded-md bg-[#d4d1ca]/90 dark:bg-gray-700" />
            <div className="h-8 w-24 rounded-md bg-[#d4d1ca]/70 dark:bg-gray-700" />
            <div className="h-8 w-24 rounded-md bg-[#d4d1ca]/70 dark:bg-gray-700" />
          </div>
          <div className="space-y-2">
            {Array.from({ length: 12 }).map((_, i) => (
              <div
                key={i}
                className="h-3 rounded bg-[#d4d1ca]/60 dark:bg-gray-700"
                style={{ width: `${70 + ((i * 17) % 30)}%` }}
              />
            ))}
          </div>
        </div>
        <div className="min-h-[280px] rounded-xl border border-[#d4d1ca] bg-[#f0eeea]/90 dark:border-gray-700 dark:bg-gray-900/40">
          <div className="p-3">
            <div className="mb-3 h-4 w-32 rounded bg-[#d4d1ca]/90 dark:bg-gray-700" />
            <div className="space-y-2">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="h-3 w-full rounded bg-[#d4d1ca]/60 dark:bg-gray-700" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
